import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import getDiscountPrice from 'helpers/get-discount-price';
import getPriceLabel from 'helpers/get-price-label';
import {PriceObject} from 'types';

export interface TotalPriceProps {
  price: PriceObject;
  sale?: PriceObject['amount'];
}

const Container = styled.div`
  display: grid;
  text-align: right;
`;

const PrevPrice = styled.span`
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  text-decoration: line-through;
`;

const Price = styled.span`
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
`;

/**
 * The component render total price
 * @param {TotalPriceProps} props
 * @return {React.ReactElement<TotalPriceProps>}
 * @constructor
 */
export default function TotalPrice(
    props: TotalPriceProps,
): React.ReactElement<TotalPriceProps> {
  /**
   * Render the prev price
   * @return {JSX.Element | undefined}
   */
  function renderPrevPrice(): JSX.Element | undefined {
    return props.sale ? (
      <PrevPrice>
        {getPriceLabel(props.price)}
      </PrevPrice>
    ) : undefined;
  }

  /**
   * Render the total price
   * @return {JSX.Element}
   */
  function renderPrice(): JSX.Element {
    return (
      <Price>
        {props.sale ? (
          getPriceLabel(getDiscountPrice(props.price, props.sale))
        ) : (
          getPriceLabel(props.price)
        )}
      </Price>
    );
  }

  return (
    <Container>
      {renderPrevPrice()}
      {renderPrice()}
    </Container>
  );
}
